import { useState } from 'react';
import { useScrollAnimation } from '../../hooks/useScrollAnimation';
import { useStore } from '../../data/store';
import { api } from '../../data/api';
import { Bell } from 'lucide-react';

export default function Countdown() {
  const event = useStore((s) => s.event);
  const [showModal, setShowModal] = useState(false);

  const formatBannerDate = () => {
    if (!event?.dateStart) return '5. SEPTEMBER 2026';
    const start = new Date(event.dateStart + 'T00:00:00');
    const end = event.dateEnd ? new Date(event.dateEnd + 'T00:00:00') : null;
    const opts = { day: 'numeric', month: 'long', year: 'numeric' };
    if (!end || event.dateStart === event.dateEnd) {
      return start.toLocaleDateString('de-DE', opts).toUpperCase();
    }
    if (start.getMonth() === end.getMonth() && start.getFullYear() === end.getFullYear()) {
      return `${start.getDate()}. & ${end.toLocaleDateString('de-DE', opts)}`.toUpperCase();
    }
    return `${start.toLocaleDateString('de-DE', opts)} – ${end.toLocaleDateString('de-DE', opts)}`.toUpperCase();
  };
  const [email, setEmail] = useState('');
  const [msg, setMsg] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [ref, isVisible] = useScrollAnimation();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setSubmitting(true);
    try {
      await api.public.subscribe(email);
      setMsg('Du wirst erinnert!');
      setEmail('');
      setTimeout(() => setShowModal(false), 2000);
    } catch (err) {
      setMsg(err.message || 'Fehler');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section className="bg-bg-secondary border-y border-divider">
      <div
        ref={ref}
        className={`max-w-4xl mx-auto px-5 py-10 md:py-12 flex flex-col sm:flex-row items-center justify-between gap-6 transition-all duration-700 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
        }`}
      >
        <div className="text-center sm:text-left">
          <p className="font-heading text-text-primary tracking-wider text-base md:text-lg">
            {formatBannerDate()} <span className="text-accent-red mx-2">•</span> {event?.venue ? event.venue.toUpperCase() : 'BAD HÖNNINGEN'}
          </p>
          <p className="font-body text-text-muted text-sm mt-1">Eintritt frei — Nicht verpassen.</p>
        </div>

        <button
          onClick={() => setShowModal(true)}
          className="flex items-center gap-2 border-2 border-accent-red text-accent-red font-heading tracking-[2px] text-sm uppercase px-7 py-3 hover:bg-accent-red hover:text-white transition-all min-h-[44px] shrink-0"
        >
          <Bell size={16} />
          ERINNERUNG AKTIVIEREN
        </button>
      </div>

      {showModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 px-4" onClick={() => setShowModal(false)}>
          <div className="bg-bg-card p-6 sm:p-8 max-w-md w-full border border-divider" onClick={(e) => e.stopPropagation()}>
            <h3 className="font-heading text-2xl text-text-primary mb-4">ERINNERUNG AKTIVIEREN</h3>
            <p className="text-text-muted font-body text-sm mb-6">Wir benachrichtigen dich, sobald es Neuigkeiten gibt.</p>
            <form onSubmit={handleSubmit}>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Deine E-Mail"
                required
                className="w-full bg-bg-secondary border border-divider px-4 py-3 text-text-primary font-body text-base placeholder:text-text-muted focus:outline-none focus:border-accent-red mb-4 min-h-[48px]"
              />
              <button type="submit" disabled={submitting} className="w-full bg-accent-red text-white font-heading tracking-wider px-6 py-3 border-2 border-accent-red hover:bg-transparent hover:text-accent-red transition-all min-h-[48px] disabled:opacity-50">
                {submitting ? 'ANMELDEN...' : 'JETZT ANMELDEN'}
              </button>
            </form>
            {msg && <p className="text-accent-red font-body text-sm mt-4 text-center">{msg}</p>}
          </div>
        </div>
      )}
    </section>
  );
}
